import { FeedbackResponseSchema } from '@app/core/api/feedback';

/**
 * Feedback state interface for NgRx store
 */
export interface FeedbackState {
  // Feedback submission
  submitting: boolean;
  submitError: string | null;
  lastSubmittedFeedback: FeedbackResponseSchema | null;
  
  // Feedback dismissal
  dismissing: boolean;
  dismissError: string | null;
  
  // Feedback history
  feedbackHistory: FeedbackResponseSchema[];
  historyLoading: boolean;
  historyError: string | null;
  historySkip: number;
  historyLimit: number;
  historyHasMore: boolean;
}

/**
 * Initial state for feedback feature
 */
export const initialFeedbackState: FeedbackState = {
  submitting: false,
  submitError: null,
  lastSubmittedFeedback: null,
  
  dismissing: false,
  dismissError: null,
  
  feedbackHistory: [],
  historyLoading: false,
  historyError: null,
  historySkip: 0,
  historyLimit: 10,
  historyHasMore: true
};
